const sliderSections = document.querySelectorAll(".consumables-slider-section");
sliderSections.forEach((sliderSection, i) => {
  const slider = tns({
    container: sliderSection.querySelector(".slider"),
    items: 1,
    // center: true,
    autoplay: false,
    controls: true,
    nav: true,
    navContainer: sliderSection.querySelector(".tns-controls"),
    loop: true,
    autoplayButtonOutput: false,
    controls: false,

    // controlsContainer: sliderSection.querySelector(".slider-controls"),
    speed: 800,
    gutter: 12,
    fixedHeight: true,
  });
});
